export const mutations = {
    setNCM(state, NCM) {
        state.NCM = NCM
    },
    setNCMs(state, NCMs) {
        state.NCMs = NCMs
    },
    addNCM(state, data){
        state.NCMs.push(data)
    },
    removeNCM(state, data){
        let index = state.NCMs.map(x => x.id).indexOf(data.id);
        state.NCMs.splice(index, 1)
    },
    setModalCadastrarNCM(state, status) {
        state.modalCadastrarNCM = status
    },
    setModalAtualizarTabelaNCM(state, status) {
        state.modalAtualizarTabelaNCM = status
    },
    setModalExcluirNCM(state, status) {
        state.modalExcluirNCM = status
    },
}

export default {}